module.exports = __webpack_public_path__ + "webpc/img/icon_gz_1.d6391eaa.png";